export default __webpack_public_path__ + "static/media/r.2c5b9fbf.svg";